import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";

export const RiskScoreDialog = ({
  showModal,
  handleProceed,
  riskScoreType,
  skin,
  setIsOpenRiskScore,
}) => {
  const { t } = useTranslation("");

  return (
    <StyledModal isOpen={showModal}>
      <StyledModalBody register>
        <p
          dangerouslySetInnerHTML={{
            __html: t("label_" + riskScoreType),
          }}
        ></p>
      </StyledModalBody>
      {riskScoreType === "responsible_gaming_event_rgmrs_triggered" ? (
        <StyledModalFooter position>
          <StyledButton
            banktransfer
            pub={skin === "pub"}
            onClick={() => setIsOpenRiskScore(false)}
          >
            {t("label_ok", "Ok")}
          </StyledButton>
        </StyledModalFooter>
      ) : (
        <StyledModalFooter>
          <StyledButton
            btnBold
            pub={skin === "pub"}
            onClick={() => setIsOpenRiskScore(false)}
          >
            {t("label_accept")}
          </StyledButton>
          <StyledButton
            btnBold
            pub={skin === "pub"}
            onClick={() => handleProceed()}
          >
            {t("label_contest_decision")}
          </StyledButton>
        </StyledModalFooter>
      )}
    </StyledModal>
  );
};
